import { WorkspaceTaskCountersDto } from '@api/Api';

export interface IWorkspaceCountersState {
  allTasks: WorkspaceTaskCountersDto;
  myTasks: WorkspaceTaskCountersDto;
  assignedToMeTasks: WorkspaceTaskCountersDto;
  deletedTasks: WorkspaceTaskCountersDto;
}

export interface IWorkspaceCountersAction {
  type: string;
  payload?: any;
}

export enum WorkspaceCountersTypes {
  SET_WORKSPACE_COUNTERS = 'SET_WORKSPACE_COUNTERS',
  UPDATE_WORKSPACE_COUNTERS = 'UPDATE_WORKSPACE_COUNTERS'
}
